import type { WidgetAction, WidgetActions } from "@/types";
import type { ActionsSlice, SliceCreator } from "@/state";

const noop: WidgetAction = () => {};

export const noopActions: WidgetActions = {
  loginFn: noop,
  reLoginFn: noop,
  logoutFn: noop,
  gotoProfileFn: noop,
  openChatbotFn: noop,
  continueChatbotFn: noop,
  closeChatbotFn: noop,
};

export const createActionsSlice: SliceCreator<ActionsSlice> = (set) => ({
  actions: noopActions,
  setActions: (actions) =>
    set(() => ({ actions }), false, "actions/setActions"),
  resetActions: () =>
    set({ actions: noopActions }, false, "actions/resetActions"),
});
